// This JavaScript file is created by Cision for all our modules.
// This is the first version of this file so far.
// This file works as a dictionary for all the modules and could be combined with all of them.

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};

cision.websolution.texts["sv"] = {
    // sharegraph translations
    TextComparison: "Jämförelser",
    TextIndicator: "Indikatorer",
    TextOption: "Alternativ",
    TextCompSubtitle: "Jämförelsetyp",
    TextViewSubtitle: "Visa vy",
    TextPercent: "Procent",
    TextNone: "Ingen Jämförelse",
    TextShowVolume: "Visa Volym",
    TextPartOfDay: "1D",
    TextEndOfDay: "Default Vy",
    TextReport: "Rapporter",
    TextPress: "Pressmeddelanden",
    TextIndex: "Index",
    TextPeers: "Konkurrenter",
    TextReleases: "Kurspåverkande Information",
    TextClose: "Stäng",
    TextIntra: "1D",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Å",
    TextInsider: "Insynshandel",
    TextDividend: "Utdelning",
    TextDownload: "Ladda ner",
    TextPrintChart: "Skriv ut graf",
    TextDownloadAsPNG: "Exportera som PNG",
    TextDownloadAsJPEG: "Exportera som JPEG",
    TextDownloadAsSVG: "Exportera som SVG",
    TextDownloadAsPDF: "Exportera som PDF",
    TextDownloadShareHistory: "Ladda ned historisk aktiedata",
    TextShareOptions: "Val för aktie",
    TextOrderBook: "Orderdjup",
    TextTrades: "Senaste avslut",
    TextPerformance: "Aktiedata",

    // Insider translations
    TextInsiderTrans: "Insynshandel",
    TextInsiderPersons: "Insynspersoner",
    TextDate: "Datum",
    TextDateTime: "Datum och tid",
    TextBack: "Tillbaka",
    TextInsiderPerson: "Insynsperson",
    TextPosition: "Befattning",
    TextInstrument: "Värdepapper",
    TextTransaction: "Transaktion",
    TextFrom: "Från",
    TextTo: "Till",
    TextHoldings: "Innehav",
    TextSecurity: "Säkerhet",
    TextTransactions: "Transaktioner",
    TextLastTransaction: "Senaste Transaktion",
    TextHolder: "Innehavare",

    // Ticker translations
    TextSharePriceSEK: "Aktiekurs i SEK",
    TextChangeInSEK: "Förändring i SEK",
    TextChangeInPercent: "Förändring i procent",

    // other ir modules translations
    TextNumberRec: "Antal rekommendationer",
    TextHeader1: "Aktieinformation",
    TextHeader2: "Nuvarande distrubution av rekommendationer",
    TextLastUpdate: "Senast uppdaterad",
    TextName: "Namn",
    TextBuy: "Köp",
    TextStrongBuy: "Starkt köp",
    TextVolume: "Volym",
    TextSell: "Sälj",
    TextStrongSell: "Starkt sälj",
    TextHold: "Avvakta",
    TextMean: "Medelvärde",
    TextSymbol: "Symbol",
    TextCurrency: "Valuta",
    TextMarketPlace: "Marknadsplats",
    TextLatestPrice: "Senaste pris",
    TextClosingPrice: "Stängningspris",
    TextLatestChange: "Senaste förändring",
    TextLastChange: "Senast förändring",
    TextAtHigh: "Toppnotering",
    TextAtLast: "Lägsta notering",
    TextYearHigh: "Årshögsta",
    TextYearLow: "Årslägsta",
    TextNumberOfShares: "Antal aktier",
    TextShareValue: "Value",
    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose your share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",
    TextNoTradesYet: "Det har inte skett någon handel ännu",

    TextPrice: "Pris",
    TextBuyer: "Köpare",
    TextSeller: "Säljare",
    TextTime: "Tid",
    TextAsk: "Sälj",
    TextBid: "Köp",
    TextHigh: "Högst",
    TextLow: "Lägst",
    TextTotal: "Totalt antal aktier",
    TextVotes: "Antal röster %",
    TextValue: "Värde",
    TextShare: "Aktie",
    TextHolders: "Aktieägare",
    TextValueSEK: "Värde i SEK",
	TextValueKSEK: "Värde i KSEK",
    TextArea: "Area Namn",
    TextOwnershipAreaNames: {
        'Sweden': 'SVERIGEBOENDE',
        'Usa': 'USA',
        'Nordic': 'ÖVRIGA NORDEN',
        'Europe': 'ÖVRIGA EUROPA',
        'World': 'ÖVRIGA VÄRLDEN',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextTurnover: "Omsättning",
    TextMarket: "Totala börsvärdet",
    TextLatest: "Senaste",
    TextAnnual: "Årliga",
    TextQuarterly: "Kvartalsvisa",
    TextHistorical: "Historiska",
    TextRec: "Rekommendationer",
    TextHistoricalRec: "Historiska Rekommendationer",
    TextSME: "Uppskattningarna samlas in och beräknas av <a href='http://www.direkt.se' target='_blank'> SME Direkt. </a> Beräkningarna är baserade på prognoser från svenska och internationella analytiker. SME Direkt är Nordens ledande konsensusestimattjänst och omfattar 149 nordiska företag. SME Direkt grundades 1994 och är en del av Nyhetsbyrån Direkt. Medverkande är de ledande bankerna och mäklarna i Norden och internationella investmentbanker.",
    TextSource: "Källa",
    TextLargest: "Största Aktieägarna",
    TextRange: "Storleksklasser",
    TextDist: "Geografisk fördelning",
    TextGrouped: "Största Grupperade Aktieägarna",
    TextAnalyticsCount: "Antal analytiker",

    // general translations
    TextPrintOrderFail: "Ett fel uppstod och din beställning har inte gått igenom. Var vänlig kontrollera alla uppgifter och försk igen.",
    TextPrintOrderSuccess: "Du har beställt följande trycksaker: ",
    TextCompany: "Företag",
    TextAddress: "Adress",
    TextPostalCode: "Postkod",
    TextSubmit: "Skicka",
    TextCity: "Stad",
    TextCountry: "Land",
    TextQuantity: "Kvantitet",
    Languages: {
        sv: "Svenska",
        en: "Engelska",
        fi: "Finska",
        da: "Danska",
        no: "Norska",
        de: "Tyska",
        fr: "Franska",
        pt: "Portugisiska",
        nl: "Holländska"
    },
    TextAttachment: "Bilagor",
    TextWhenWhere: "Var och När",
    TextDigitalVersion: "Digital version",
    TextRequired: "Obligatoriska fält",
    TextFirstEvent: "Nästkommande händelse",
    TextEvents: "Händelser",
    TextEvent: "Händelse",
    TextAddToCal: "Lägg till i din kalender",
    TextUpcomingEvents: "Kommande händelser",
    TextEventArchive: "Arkiv",
    TextTitle: "Titel",
    TextPrintLang: "Tryckspråk",
    TextPrintLink: "Länk till digital version",
    TextPrintQuant: "Kvantitet att beställa",
    TextOrderPrint: "Beställ trycksaker",
    TextAll: "Allt",
    TextPrintOrderSuccessHeader: "Beställningen mottagen!",
    TextPrintOrderFailHeader: "Beställningen misslyckades!"
};

//DPS = utdelning per aktie
//Sales = Omsättning
//EPS = Vinst per aktie
//EBIT = Rörelseresultat

cision.websolution.texts["en"] = {
    // Sharegraph translations
    TextComparison: "Comparisons",
    TextIndicator: "Indicators",
    TextOption: "Options",
    TextCompSubtitle: "Comparison Type",
    TextViewSubtitle: "Show View",
    TextPercent: "Percent",
    TextNone: "Price",
    TextShowVolume: "Show Volume",
    TextPartOfDay: "1D",
    TextEndOfDay: "Default View",
    TextReport: "Reports",
    TextPress: "Press Releases",
    TextIndex: "Index",
    TextPeers: "Peers",
    TextReleases: "Regulatory Information",
    TextClose: "Close",
    TextIntra: "1D",
    Text1V: "1W",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "All",
    TextInsider: "Insider",
    TextDividend: "Dividend",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",

    // Ticker translations
    TextSharePriceSEK: "Share price in SEK",
    TextChangeInSEK: "Change in SEK",
    TextChangeInPercent: "Change in %",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextValue: "Value",
    TextShare: "Share",
    TextHolders: "Share Holders",
    TextValueKSEK: "Value in KSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='http://www.direkt.se' target='_blank'>SME Direkt.</a>  The estimates are based on projections from Swedish and International Analysts. SME Direkt is the leading Nordic consensus estimates service and it covers 149 Nordic companies. SME Direkt was founded in 1994 and is a part of Nyhetsbyrån Direkt. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccess: "Order successful!",
    TextPrintOrderFail: "Order failed!"

};

// dk, fi, no and de translations is not complete.

cision.websolution.texts["dk"] = {
    // Sharegraph translations
    TextComparison: "Sammenligninger",
    TextIndicator: "Indikatorer",
    TextOption: "Optioner",
    TextCompSubtitle: "Sammenligning",
    TextViewSubtitle: "Vis",
    TextPercent: "Procent",
    TextValue: "Værdi",
    TextNone: "Pris",
    TextShowVolume: "Vis volumen",
    TextPartOfDay: "Intraday",
    TextEndOfDay: "Standardvisning",
    TextReport: "Rapporter",
    TextPress: "Pressemeddelelser",
    TextIndex: "Indeks",
    TextPeers: "Sammenlignelige virksomheder",
    TextReleases: "Lovmæssig information",
    TextClose: "Luk",
    TextIntra: "Intraday",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Udbytte",

    // Insiders translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextShare: "Share",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history"
};

cision.websolution.texts["no"] = {
    // Sharegraph translations
    TextComparison: "Sammenligninger",
    TextIndicator: "Indikatorer",
    TextOption: "Alternativer",
    TextCompSubtitle: "Sammenligningstype",
    TextViewSubtitle: "visning",
    TextPercent: "Prosent",
    TextValue: "Verdi",
    TextNone: "Pris",
    TextShowVolume: "Vis volum",
    TextPartOfDay: "I løpet av dagen",
    TextEndOfDay: "Standard visning",
    TextReport: "Rapporter",
    TextPress: "Pressemeldinger",
    TextShare: "Aksje",
    TextIndex: "Stikkordliste",
    TextPeers: "Likestilte",
    TextReleases: "Regulerende informasjon",
    TextClose: "Lukk",
    TextIntra: "I løpet av dagen",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Utbytte",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",

    // Ticker translations
    TextSharePriceSEK: "Share price in SEK",
    TextChangeInSEK: "Change in SEK",
    TextChangeInPercent: "Change in %",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextValue: "Value",
    TextShare: "Share",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
	TextValueKSEK: "Value in KSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='http://www.direkt.se' target='_blank'>SME Direkt.</a>  The estimates are based on projections from Swedish and International Analysts. SME Direkt is the leading Nordic consensus estimates service and it covers 149 Nordic companies. SME Direkt was founded in 1994 and is a part of Nyhetsbyrån Direkt. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccess: "Order successful!",
    TextPrintOrderFail: "Order failed!"
};

cision.websolution.texts["fi"] = {
    // Sharegraph translations
    TextComparison: "Vertailut",
    TextIndicator: "Indikaattorit",
    TextOption: "Vaihtoehdot",
    TextCompSubtitle: "Vertailutyyppi",
    TextViewSubtitle: "Näytä näkymä",
    TextPercent: "Prosentti",
    TextValue: "Arvo",
    TextNone: "Hinta",
    TextShowVolume: "Näytä volyymi",
    TextPartOfDay: "Päiväkauppa",
    TextEndOfDay: "Oletusnäkymä",
    TextReport: "Raportit",
    TextPress: "Lehdistötiedotteet",
    TextShare: "Osake",
    TextIndex: "Indeksi",
    TextPeers: "Vertaisryhmään kuuluvat",
    TextReleases: "Sääntelytiedot",
    TextClose: "Sulje",
    TextIntra: "1PÄ",
    Text1V: "1VI",
    Text1M: "1KU",
    Text3M: "3KU",
    Text6M: "6KU",
    Text1Y: "1VU",
    TextAll: "Kaikki",
    TextInsider: "Sisäpiiriläinen",
    TextDividend: "Osinko",
    TextDownload: "Lataa",
    TextPrintChart: "Tulosta graafi",
    TextDownloadAsPNG: "Vie PNG:nä",
    TextDownloadAsJPEG: "Vie JPEG:nä",
    TextDownloadAsSVG: "Vie SVG:nä",
    TextDownloadAsPDF: "Vie PDF:nä",
    TextDownloadShareHistory: "Lataa kurssitieto",
    TextShareOptions: "Osakevalinnat",
    TextOrderBook: "Tilauskanta",
    TextTrades: "Viimeisimmät kaupat",
    TextPerformance: "Kaupankäyntitieto",
    // Insider translations
    TextInsiderTrans: "Sisäpiirin kaupat",
    TextInsiderPersons: "Sisäpiiriläiset",
    TextDate: "Päivämäärä",
    TextDateTime: "Päivämäärä ja aika",
    TextBack: "Takaisin",
    TextInsiderPerson: "Sisäpiiriläinen",
    TextPosition: "Asema",
    TextInstrument: "Instrumentti",
    TextTransaction: "Liiketoimi",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Omistukset",
    TextSecurity: "Security",
    TextTransactions: "Liiketoimet",
    TextLastTransaction: "Viimeisin liiketoimi",
    TextHolder: "Omistaja",

    // Ticker translations
    TextSharePriceSEK: "Share price in SEK",
    TextChangeInSEK: "Change in SEK",
    TextChangeInPercent: "Change in %",

    // other ir modules translations
    TextNumberRec: "Suositusten määrä",
    TextHeader1: "Osaketieto",
    TextHeader2: "Suositusten jakauma",
    TextLastUpdate: "Viimeisin päivitys",
    TextName: "Nimi",
    TextBuy: "Osta",
    TextStrongBuy: "Vahva osta",
    TextVolume: "Volyymi",
    TextSell: "Myy",
    TextStrongSell: "Vahva myy",
    TextHold: "Pidä",
    TextMean: "Keskiarvo",
    TextSymbol: "Tunnus",
    TextCurrency: "Valuutta",
    TextMarketPlace: "Markkinapaikka",
    TextLatestPrice: "Viimeisin hinta",
    TextClosingPrice: "Päätöskurssi",
    TextLatestChange: "Viimeisin muutos",
    TextLastChange: "Viimeisin muutos",
    TextAtHigh: "Kaikkien aikojen ylin",
    TextAtLast: "Kaikkien aikojen alin",
    TextYearHigh: "Vuoden ylin",
    TextYearLow: "Vuoden alin",
    TextNumberOfShares: "Osakkeiden lukumäärä",
    TextShareValue: "Arvo",
    TextShareCompute: "Laske",
    TextPurchaseDate: "Ostopäivämäärä",
    TextShareType: "Osaketyyppi",
    TextShareTypeHelp: "Valitse osaketyyppi",
    TextShareSettings: "Asetukset",
    TextDownloadResultsAndShareHistory: "Lataa tulos- ja osaketiedot",
    TextPeriodHelp: "Valitse aikaväli",
    TextYear: "Vuosi",
    TextMonth: "Kuukausi",
    TextDay: "Päivä",
    TextFromIncluding: "Alkaen",
    TextToIncluding: "Asti",
    TextNumberOfSharesHelp: "Syötä osakkeiden lukumäärä tai omistustesi arvo",
    TextOpenPrice: "Avauskurssi",
    TextChange: "Muutos",
    TextShareCalculatorResults: "Tulokset",
    TextShareCalculatorHistory: "Historia",
    TextInitialInvestment: "Alkuperäinen sijoitus",
    TextEndValue: "Päätösarvo",
    TextSharePrice: "Osakehinta",
    TextSharesBought: "Ostetut osakkeet",
    TextAnnualizedChange: "Annualisoitu muutos",
    TextEndOfTheDay: "Päivän päätös",
    TextPartOfTheDay: "Päivän osa",
    TextNoTradesYet: "Ei vielä kauppoja",
    TextPrice: "Hinta",
    TextBuyer: "Ostaja",
    TextSeller: "Myyjä",
    TextTime: "Aika",
    TextAsk: "Myynti",
    TextBid: "Osto",
    TextHigh: "Ylin",
    TextLow: "Alin",
    TextTurnover: "Liikevaihto",
    TextMarket: "Markkina-arvo",
    TextTotal: "Osakkeiden lukumäärä",
    TextVotes: "Äänet %",
    TextHolders: "Osakkeenomistajat",
    TextValueSEK: "Arvo SEK",
	TextValueKSEK: "Arvo KSEK",
    TextArea: "Aluenimi",
    TextOwnershipAreaNames: {
        'Sweden': 'RUOTSI',
        'Usa': 'USA',
        'Nordic': 'MUUT POHJOISMAAT',
        'Europe': 'MUU EUROOPPA',
        'World': 'MUU MAAILMA',
        'Total': 'YHTEENSÄ'
    },
    TextVoting: "Äänestysoikeudet",
    TextLatest: "Viimeisin",
    TextAnnual: "Vuosittainen",
    TextQuarterly: "Neljännesvuosittainen",
    TextHistorical: "Historiallinen",
    TextRec: "Suositukset",
    TextHistoricalRec: "Historialliset suositukset",
    TextSME: "Arviot kerätään ja lasketaan <a href='http://www.direkt.se' target='_blank'>SME Direktin.</a> toimesta. Arviot perustuvat ruotsalaisten ja kansainvälisten analyytikoiden näkemyksiin. SME Direkt on Pohjoismaiden johtava konsensusarviopalvelu, joka kattaa 149 Pohjoismaalaista yritystä. SME Direkt perustettiin 1994 ja on osa Nyhetsbyrån Direktiä. Arvioiden tuottajina toimivat Pohjoismaiset johtavat pankit ja välittäjät sekä kansainväliset investointipankit. ",
    TextSource: "Lähde",
    TextLargest: "Suurimmat osakkeenomistajat",
    TextRange: "Osakevaihtelut",
    TextDist: "Maantieteellinen jakauma",
    TextGrouped: "Suurimmat osakkeenomistajat ryhmiteltyinä",
    TextAnalyticsCount: "Analyytikot",

    // general translations
    TextCompany: "Yritys",
    TextAddress: "Osoite",
    TextPostalCode: "Postinumero",
    TextSubmit: "Lähetä",
    TextCity: "Kaupunki",
    TextCountry: "Maa",
    TextQuantity: "Määrä",
    Languages: {
        sv: "ruotsi",
        en: "englanti",
        fi: "suomi",
        de: "tanska",
        no: "norja",
        ge: "saksa",
        fr: "ranska",
        pt: "portugali",
        nl: "hollanti"
    },
    TextAttachment: "Liitteet",
    TextWhenWhere: "Missä ja milloin",
    TextDigitalVersion: "Digitaalinen versio",
    TextRequired: "Vaaditut kentät",
    TextFirstEvent: "Seuraava tapahtuma",
    TextEvents: "Tapahtumat",
    TextEvent: "Tapahtuma",
    TextAddToCal: "Lisää kalenteriisi",
    TextUpcomingEvents: "Tulevat tapahtumat",
    TextEventArchive: "Arkisto",
    TextTitle: "Otsikko",
    TextPrintLang: "Painokieli",
    TextPrintLink: "Linkki digitaaliseen versioon",
    TextPrintQuant: "Tilausmäärä",
    TextOrderPrint: "Tilaa tulostettuina",
    TextPrintOrderSuccess: "Tilaus onnistui",
    TextPrintOrderFail: "Tilaus epäonnistui",
    TextPrintOrderFail: "Tilaus epäonnistui, ota yhteyttä asiakaspalveluun",
    TextPrintOrderSuccess: "Olet tilannut seuraavat tuotteet"
};

cision.websolution.texts["de"] = {
    // Sharegraph translations
    TextComparison: "Vergleiche",
    TextIndicator: "Indikatoren",
    TextOption: "Optionen",
    TextCompSubtitle: "Vergleichstyp",
    TextViewSubtitle: "Ansicht anzeigen",
    TextPercent: "Prozent",
    TextValue: "Wert",
    TextNone: "Preis",
    TextShowVolume: "Menge anzeigen",
    TextPartOfDay: "Intra Day",
    TextEndOfDay: "Standardansicht",
    TextReport: "Berichte",
    TextPress: "Pressemitteilungen",
    TextShare: "Aktie",
    TextIndex: "Index",
    TextPeers: "Fachkollegen",
    TextReleases: "Vorgeschriebene Information",
    TextClose: "Schließen",
    TextIntra: "Intraday",
    Text1V: "1V",
    Text1M: "1M",
    Text3M: "3M",
    Text6M: "6M",
    Text1Y: "1Y",
    TextAll: "Alle",
    TextInsider: "Insider",
    TextDividend: "Dividende",
    TextPrintChart: "Print graph",
    TextDownloadAsPNG: "Export as PNG",
    TextDownloadAsJPEG: "Export as JPEG",
    TextDownloadAsSVG: "Export as SVG",
    TextDownloadAsPDF: "Export as PDF",
    TextShareOptions: "Share options",
    TextOrderBook: "Order book",
    TextTrades: "Trades",
    TextPerformance: "Performance",

    // Insider translations
    TextInsiderTrans: "Insider transactions",
    TextInsiderPersons: "Insider persons",
    TextBack: "Back",
    TextInsiderPerson: "Insider",
    TextPosition: "Position",
    TextInstrument: "Instrument",
    TextTransaction: "Transaction",
    TextFrom: "From",
    TextTo: "To",
    TextHoldings: "Holdings",
    TextSecurity: "Security",
    TextTransactions: "Transactions",
    TextLastTransaction: "Last Transaction",
    TextHolder: "Holder",

    // Ticker translations
    TextSharePriceSEK: "Share price in SEK",
    TextChangeInSEK: "Change in SEK",
    TextChangeInPercent: "Change in %",

    // other ir modules translations
    TextNumberRec: "Number of recommendations",
    TextHeader1: "Share Information",
    TextHeader2: "Current distribution of recommendations",
    TextLastUpdate: "Latest update",
    TextName: "Name",
    TextBuy: "Buy",
    TextStrongBuy: "Strong buy",
    TextSell: "Sell",
    TextStrongSell: "Strong sell",
    TextHold: "Hold",
    TextMean: "Mean",
    TextSymbol: "Symbol",
    TextCurrency: "Currency",
    TextMarketPlace: "Market place",
    TextLatestPrice: "Latest price",
    TextClosingPrice: "Closing price",
    TextLatestChange: "Latest change",
    TextAtHigh: "All time high",
    TextAtLast: "All time low",
    TextYearHigh: "Year high",
    TextYearLow: "Year low",
    TextNumberOfShares: "Number of shares",
    TextShareValue: "Value",
    TextNoTradesYet: "There has not been any trades yet",

    TextShareCompute: "Compute",
    TextPurchaseDate: "Purchase date",
    TextShareType: "Share type",
    TextShareTypeHelp: "Choose you share type",
    TextShareSettings: "Settings",
    TextDownloadResultsAndShareHistory: "Download results and share history",
    TextPeriodHelp: "Enter the time period",
    TextYear: "Year",
    TextMonth: "Month",
    TextDay: "Day",
    TextFromIncluding: "From including",
    TextToIncluding: "To including",
    TextNumberOfSharesHelp: "Enter number of shares OR the value of your holdings",
    TextOpenPrice: "Open price",
    TextChange: "Change",
    TextShareCalculatorResults: "Results",
    TextShareCalculatorHistory: "History",
    TextInitialInvestment: "Initial investment",
    TextEndValue: "End value",
    TextSharePrice: "Share price",
    TextSharesBought: "Shares bought",
    TextAnnualizedChange: "Annualized change",
    TextEndOfTheDay: "End of the day",
    TextPartOfTheDay: "Part of the day",

    TextPrice: "Price",
    TextBuyer: "Buyer",
    TextSeller: "Seller",
    TextTime: "Time",
    TextAsk: "Ask",
    TextBid: "Bid",
    TextHigh: "High",
    TextLow: "Low",
    TextVolume: "Volume",
    TextTurnover: "Turnover",
    TextMarket: "Total Market Cap",
    TextTotal: "Total Shares",
    TextVotes: "Votes %",
    TextValue: "Value",
    TextShare: "Share",
    TextHolders: "Share Holders",
    TextValueSEK: "Value in SEK",
	TextValueKSEK: "Value in KSEK",
    TextArea: "Area Name",
    TextOwnershipAreaNames: {
        'Sweden': 'SWEDEN',
        'Usa': 'USA',
        'Nordic': 'REST OF NORDICS',
        'Europe': 'REST OF EUROPE',
        'World': 'REST OF WORLD',
        'Total': 'TOTAL'
    },
    TextVoting: "Voting Rights",
    TextLatest: "Latest",
    TextDownload: "Download",
    TextDownloadShareHistory: "Download share history",
    TextAnnual: "Annual",
    TextQuarterly: "Quarterly",
    TextHistorical: "Historical",
    TextRec: "Recommendations",
    TextHistoricalRec: "Historical Recommendations",
    TextSME: "The estimates are collected and calculated by <a href='http://www.direkt.se' target='_blank'>SME Direkt.</a>  The estimates are based on projections from Swedish and International Analysts. SME Direkt is the leading Nordic consensus estimates service and it covers 149 Nordic companies. SME Direkt was founded in 1994 and is a part of Nyhetsbyrån Direkt. Contributors are the leading banks and brokers in the Nordic area and international investment banks.",
    TextSource: "Source",
    TextLargest: "Largest Shareholders",
    TextRange: "Share Ranges",
    TextDist: "Geographical Distribution",
    TextGrouped: "Largest Grouped Shareholders",
    TextAnalyticsCount: "Covering analysts",

    // general translations
    TextCompany: "Company",
    TextAddress: "Address",
    TextPostalCode: "Postal code",
    TextSubmit: "Send",
    TextCity: "City",
    TextLanguage: "Language code",
    TextCountry: "Country",
    TextQuantity: "Quantity",
    Languages: {
        sv: "Swedish",
        en: "English",
        fi: "Finnish",
        de: "Danish",
        no: "Norweigian",
        ge: "German",
        fr: "French",
        pt: "Portugese",
        nl: "Dutch"
    },
    TextAttachment: "Attachments",
    TextWhenWhere: "When and Where",
    TextDigitalVersion: "Digital version",
    TextRequired: "Required fields",
    TextFirstEvent: "Next coming event",
    TextEvents: "Events",
    TextDate: "Date",
    TextDateTime: "Date and time",
    TextEvent: "Event",
    TextAddToCal: "Add to your calendar",
    TextUpcomingEvents: "Upcoming events",
    TextEventArchive: "Archive",
    TextTitle: "Title",
    TextPrintLang: "Print language",
    TextPrintLink: "Link to digital version",
    TextPrintQuant: "Quantity to order",
    TextOrderPrint: "Order printed materials",
    TextPrintOrderSuccess: "Order successful!",
    TextPrintOrderFail: "Order failed!"
};


// $.fn.datepicker.dates['fi'] = {
//     days: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
//     daysShort: ["su", "ma", "ti", "ke", "to", "pe", "la"],
//     daysMin: ["su", "ma", "ti", "ke", "to", "pe", "la"],
//     months: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
//     monthsShort: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
//     today: "Tänään",
//     clear: "Tyhjennä",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };

cision.websolution.texts["fi"].calendarTexts = {
    weekdays: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai'],
    months: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu'],
    shortMonths: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
    rangeSelectorFrom: ['From'],
    rangeSelectorTo: ['To'],
    downloadJPEG: ['Download JPEG image'],
    downloadPDF: ['Download PDF document'],
    downloadPNG: ['Download PNG image'],
    downloadSVG: ['Download SVG vector image'],
    printChart: ['Print chart'],
    source: ['Source']
};

// $.fn.datepicker.dates['sv'] = {
//     days: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
//     daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
//     daysMin: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
//     months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
//     monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
//     today: "Idag",
//     clear: "Rensa",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };
// $.fn.datepicker.dates['en'] = {
//     days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
//     daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
//     monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     today: "Today",
//     clear: "Clear",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };
// $.fn.datepicker.dates['no'] = {
//     days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
//     daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
//     monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     today: "Today",
//     clear: "Clear",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };
// $.fn.datepicker.dates['de'] = {
//     days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
//     daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
//     monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     today: "Today",
//     clear: "Clear",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };
// $.fn.datepicker.dates['dk'] = {
//     days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
//     daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
//     daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
//     months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
//     monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
//     today: "Today",
//     clear: "Clear",
//     format: "yyyy-mm-dd",
//     titleFormat: "MM yyyy", /* Leverages same syntax as 'format' */
//     weekStart: 0
// };
cision.websolution.texts["en"].calendarTexts = {
    weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    rangeSelectorFrom: ['From'],
    rangeSelectorTo: ['To'],
    downloadJPEG: ['Download JPEG image'],
    downloadPDF: ['Download PDF document'],
    downloadPNG: ['Download PNG image'],
    downloadSVG: ['Download SVG vector image'],
    printChart: ['Print chart'],
    source: ['Source']
};

cision.websolution.texts["sv"].calendarTexts = {
    weekdays: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
    months: ['Januari', 'Februari', 'Mars', 'April', 'Maj', 'Juni', 'Juli', 'Augusti', 'September', 'Oktober', 'November', 'December'],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
    rangeSelectorFrom: ['Från'],
    rangeSelectorTo: ['Till'],
    downloadJPEG: ['Ladda ner JPEG bild'],
    downloadPDF: ['Ladda ner PDF dokument'],
    downloadPNG: ['Ladda ner PNG bild'],
    downloadSVG: ['Ladda ner SVG bild'],
    printChart: ['Skriv ut graf'],
    source: ['Källa']
};

